var _ = require('underscore');
var Activity = require('RecordActivityLog');
var Labels = EY.Consultation.Labels;

var log = function (options, text) {
    Activity.log(_.extend({ text: text }, options));
};

var activity = function (options) {
    var history = options.history;
    var record = options.record;

    log(options, history.fiscalYearEnd != record.get('fiscalYearEnd') ? Labels.Activity_ModifiedFiscalYearEnd : '');
    log(options, history.description != record.get('description') ? Labels.Activity_ModifiedDescription.replace('{0}', history.description) : '');
    log(options, history.typeId != record.get('typeId') ? Labels.Activity_ModifiedType.replace('{0}', history.type) : '');
    log(options, history.subtypeId != record.get('subtypeId') ? Labels.Activity_ModifiedSubtype.replace('{0}', history.subtype) : '');
    log(options, history.subjectId != record.get('subjectId') ? Labels.Activity_ModifiedSubject.replace('{0}', history.subject) : '');
    log(options, history.approvalBy != record.get('approvalBy') ? Labels.Activity_ModifiedApprovalNeededBy : '');
};

var approvers = function (options) {
    function removeEmptyKeys(approvers) {

        _.each(approvers, function (approver) {

            var keys = _.keys(approver);
            _.each(keys, function (key) { (approver[key] === undefined || approver[key] === '') && delete approver[key]; });
        });
    }

    var historyApprovers = _.map(options.history.approvers, _.clone);
    removeEmptyKeys(historyApprovers);

    var currentApprovers = options.approvers.toJSON();
    removeEmptyKeys(currentApprovers);

    var source = _.groupBy(historyApprovers, 'approverGroupId');
    var target = _.groupBy(currentApprovers, 'approverGroupId');

    _.each(target, function (value, level) {

        if (level !== 'TeamMember') {
            log(options, !_.isEqual(source[level], target[level]) ? Labels.Activity_Modified.replace('{0}', Labels['ApproverGroup_' + level]) : '');
        }
    });
};

var attachments = function (options) {
    var source = _.indexBy(options.history.attachments, 'id');
    var target = _.indexBy(options.attachments.toJSON(), 'id');
    var union = _.union(_.keys(source), _.keys(target)); 

    _.each(union, function (id) {
        if (!source[id] && target[id]) {
            log(options, Labels.Activity_FileUploaded.replace('{0}', target[id].filename));
        } else if (source[id] && !target[id]) {
            log(options, Labels.Activity_FileDeleted.replace('{0}', source[id].filename));
        } else if (source[id] && target[id] && source[id].date !== target[id].date) {
            log(options, Labels.Activity_FileModified.replace('{0}', target[id].filename));
        }
    });
};

module.exports.run = function (options) {
    activity(options);
    approvers(options);
    attachments(options);
};


// WEBPACK FOOTER //
// ./js/Modules/Record/Action/RecordActionActivity.js